import React from 'react';

/**
 * Where floating picker UI should portal while the lightbox is up, so it stays
 * inside the modal box instead of being clipped by it. Undefined elsewhere
 * (portals to body). See `.flowOverlayHost`.
 */
export const QuickPayPortalHostContext = React.createContext<
  HTMLElement | undefined
>(undefined);

export const useQuickPayPortalHost = () =>
  React.useContext(QuickPayPortalHostContext);
